import { type SxProps, type Theme, Typography, type TypographyProps } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import type { AnalyticsType } from '@repo/segment/types';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph-schemas/marketplace/enums';
import type { CtaType } from '@repo/supergraph-schemas/marketplace/types';

type CtaNameProps = {
  cta: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
};

export const CtaName = ({ cta, ctaAnalytics, displayName, variant, sx }: CtaNameProps) => {
  if (!cta) return null;

  return (
    <CtaLink
      cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductName }}
      monetizable={ctaAnalytics.monetizable}
      analyticsPayload={ctaAnalytics}
      linkType={LinkType.PRODUCT_NAME}
      Component={Typography}
      variant={variant}
      sx={{
        color: 'text.primary',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
        ...sx,
      }}
    >
      {displayName}
    </CtaLink>
  );
};
